import { Icon, MainHeader, MainMenu } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BrandContext } from '../../../contextProviders/brandContext';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';
import {
  CSPLiteModeMUserMenuStructure,
  CSPLiteModeMenuStructure,
  CSPMobileUserMenuStructure,
  CSPMobileMenuStructure
} from '../../../routes/CSPMenuStructure';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { AUTHENTICATION_TYPES } from '../../../constants/constants';

export const HamburgerMenu = ({ cspHeaderLogo }) => {
  const [isVisible, setIsVisible] = useState(false);

  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isLiteModeEnabled = cspConfiguration?.IsLiteModeEnabled || false;
  const isLiveVetEnabled = cspConfiguration?.IsLiveVetEnabled || false;
  const isPayNowEnabled = cspConfiguration?.IsPayNowEnabled ?? true;
  const isNotificationPreferencesEnabled = cspConfiguration?.IsNotificationPreferencesEnabled ?? true;
  const { authenticationType } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];

  const location = useLocation();
  useEffect(() => {
    if (isVisible) {
      setIsVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const {
    activeBrandContext: {
      brand,
      layout: { header }
    }
  } = useContext(BrandContext);

  const handleMenuTrigger = () => {
    setIsVisible(!isVisible);
  };
  // Remove contact details from the header configuration
  const customCspHeaderConfig = { ...header, contactDetails: null };
  const isSsoAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;

  const logOutMenuItem = {
    label: isSsoAuthentication ? 'Back to My Insurance Portal' : 'Logout',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: 'logout'
    },
    url: CSPUrlsMap.logout.url
  };

  return (
    <MainHeader
      {...{
        ...brand,
        logos: cspHeaderLogo,
        ...customCspHeaderConfig,
        customCssClass: 'withHamburgerMenu',
        headerNav: (
          <div className={`hamburgerMenu ${isVisible ? 'open' : 'closed'}`}>
            <button
              className="button primary icon_only liveVetMenuItem helpCenterMenuItem"
              onClick={handleMenuTrigger}
              type="button"
            >
              {isVisible ? <Icon icon="cross-rounded" /> : <Icon icon="menu-rounded" />}

              <span className="sr-only">Open and close main menu</span>
            </button>
            {isVisible && (
              <MainMenu
                wrapper={{
                  id: 'vertical'
                }}
                menuId="mobileMainMenu"
                isHoverTrigger={false}
                menuItems={
                  isLiteModeEnabled
                    ? [
                        ...CSPLiteModeMenuStructure(isLiveVetEnabled),
                        ...CSPLiteModeMUserMenuStructure(isSsoAuthentication)
                      ]
                    : [
                        ...CSPMobileMenuStructure(isLiveVetEnabled, isPayNowEnabled),
                        ...CSPMobileUserMenuStructure(isNotificationPreferencesEnabled),
                        logOutMenuItem
                      ]
                }
                ariaLabel="Mobile Main navigation menu"
              />
            )}
          </div>
        )
      }}
    />
  );
};

HamburgerMenu.propTypes = {
  cspHeaderLogo: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      imageTitle: PropTypes.string,
      imageTitleDescription: PropTypes.string,
      redirectUrl: PropTypes.string
    })
  )
};
